import { render, staticRenderFns } from "./Alerts1.vue?vue&type=template&id=5d95a914"
import script from "./Alerts1.vue?vue&type=script&lang=js"
export * from "./Alerts1.vue?vue&type=script&lang=js"
import style0 from "./Alerts1.vue?vue&type=style&index=0&id=5d95a914&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports